import type { SVGProps } from "react"

export const ArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" stroke="currentColor" d="m10.578 21.884 8.03-8.03.854-.854H.5v-2h18.961l-.852-.853-8.017-8.032L12 .707 23.293 12 11.999 23.294l-1.42-1.41Z" />
  </svg>
)
